import React from 'react'
import './contact.css'
import {MdOutlineEmail} from 'react-icons/md'
import {BsWhatsapp} from 'react-icons/bs'
import {FiTwitter} from 'react-icons/fi'
import { useRef } from 'react'
import emailjs from 'emailjs-com';

const Contact = () => {
  const form = useRef();
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_lzhsfpo', 'template_kf1wiui', form.current, 'WhW46Jprihp1uHV6_')

    e.target.reset()
  };

  return (
    <section id="contact">
      <h5>Get In Touch</h5>
      <h2>Contact Me</h2>

      <div className="container contact__container">
        <div className="contact__options">
          <article className="contact__option">
            <MdOutlineEmail className='contact__option-icon' />
            <h4>Email</h4>
            <h4>lyonsmasawa@gmail.com</h4>
            <h4>Click to send Mail</h4>
            <a href="mailto:lyonsmasawa@gmail.com" target='_blank' rel="noreferrer">Send an email</a>
          </article>

          <article className="contact__option">
            <FiTwitter className='contact__option-icon' />
            <h4>Twitter</h4>
            <h4>Click to send a message</h4>
            <a href="https://twitter.com/LyonsXzone" target='_blank' rel="noreferrer">Send a message</a>
          </article>

          <article className="contact__option">
            <BsWhatsapp className='contact__option-icon'/>
            <h4>WhatsApp</h4>
            <h4>Click to send a message</h4>
            <a href="https://api.whatsapp.com/send?phone=254708957380" target='_blank' rel="noreferrer">Send a message</a>
          </article>
        </div>
        
        <form ref={form} onSubmit={sendEmail}>
          <input type="text" name='name' placeholder='Your Full Name' required />
          <input type="email" name="email" placeholder='Your Email' required />
          <textarea name="message" rows="7" placeholder='Your Message' required></textarea>
          <button type='submit' className="btn btn-primary">Send Message</button>
        </form>
      </div>
    </section>
  )
}

export default Contact